import {forApiMock} from "./_helpers/forApiMock";

export const BASE_API = forApiMock(process.env.REACT_APP_API_MOCK, process.env.REACT_APP_BASE_API);
